// src/pages/RequestedOrders/RequestedOrders.jsx

import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, query, addDoc, doc, updateDoc, deleteDoc, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';

const styles = {
    container: { fontFamily: '"Inter", sans-serif' },
    box: { background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', marginBottom: '20px' },
    form: { display: 'flex', gap: '10px', marginBottom: '20px' },
    input: { flexGrow: 1, padding: '12px 15px', fontSize: '16px', border: '1px solid #ced4da', borderRadius: '4px' },
    button: { padding: '12px 20px', border: 'none', background: '#06C167', color: 'white', borderRadius: '5px', cursor: 'pointer', fontSize: '16px' },
    list: { listStyle: 'none', padding: 0, margin: 0 },
    listItem: { display: 'flex', alignItems: 'center', gap: '15px', padding: '15px', borderBottom: '1px solid #f0f0f0' },
    checkbox: { width: '20px', height: '20px', cursor: 'pointer' },
    taskText: { flexGrow: 1, fontSize: '16px' },
    taskTextCompleted: { textDecoration: 'line-through', color: '#6c757d' },
    deleteButton: { background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '20px' }
};

function RequestedOrders() {
    const { userData } = useAuth(); // DÜZELTME: currentUser yerine userData
    const [requests, setRequests] = useState([]);
    const [newRequestText, setNewRequestText] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userData?.companyId) { // DÜZELTME
            setLoading(false);
            return;
        }
        const companyId = userData.companyId;
        const q = query(collection(db, 'companies', companyId, 'requestedOrders'), orderBy('createdAt', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        return () => unsubscribe();
    }, [userData]);

    const handleAddRequest = async (e) => {
        e.preventDefault();
        if (!newRequestText.trim() || !userData?.companyId) return;
        try {
            await addDoc(collection(db, 'companies', userData.companyId, 'requestedOrders'), {
                text: newRequestText,
                isCompleted: false,
                createdAt: new Date()
            });
            setNewRequestText('');
        } catch (error) {
            console.error("İstek eklenirken hata:", error);
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        if (!userData?.companyId) return;
        const requestRef = doc(db, 'companies', userData.companyId, 'requestedOrders', id);
        await updateDoc(requestRef, {
            isCompleted: !currentStatus
        });
    };

    const handleDeleteRequest = async (id) => {
        if (!userData?.companyId) return;
        if (!window.confirm("Bu isteği silmek istediğinizden emin misiniz?")) {
            return;
        }
        const requestRef = doc(db, 'companies', userData.companyId, 'requestedOrders', id);
        await deleteDoc(requestRef);
    };

    return (
        <div style={styles.container}>
            <h1>İstek Siparişler (Yapılacaklar)</h1>
            <div style={styles.box}>
                <form onSubmit={handleAddRequest} style={styles.form}>
                    <input 
                        type="text"
                        style={styles.input}
                        value={newRequestText}
                        onChange={(e) => setNewRequestText(e.target.value)}
                        placeholder="Yeni bir sipariş isteği girin (Örn: Modako Kumaş - 50 adet kırlent)..."
                    />
                    <button type="submit" style={styles.button}>Ekle</button>
                </form>

                {loading ? <p>Yükleniyor...</p> : (
                    <ul style={styles.list}>
                        {requests.map(req => (
                            <li key={req.id} style={styles.listItem}>
                                <input 
                                    type="checkbox" 
                                    style={styles.checkbox}
                                    checked={req.isCompleted}
                                    onChange={() => handleToggleStatus(req.id, req.isCompleted)}
                                />
                                <span style={{...styles.taskText, ...(req.isCompleted && styles.taskTextCompleted)}}>
                                    {req.text}
                                </span>
                                <button onClick={() => handleDeleteRequest(req.id)} style={styles.deleteButton}>&times;</button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default RequestedOrders;
